import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { CompanyRepositoryBase } from '@skylab-shared/business';
export { CompanyRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(CompanyRepositoryBase)
export class CompanyRepository {
    public constructor(
        http: Http
    ) { }
}
